import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import { FormControl } from 'baseui/form-control'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const AdditionalInformation = () => {
  const { t, updateAddress, errors, additionalInformation } = useAddress()
  return (
    <FormControl error={getError('additionalInformation', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.additional_information')}
        onBlur={additionalInformation => updateAddress({ additionalInformation })}
        currentValue={additionalInformation}
      />
    </FormControl>
  )
}

export default AdditionalInformation
